import CwPdfEditor from "./index.vue"

export default CwPdfEditor